import React, { useEffect, useState } from "react";
import PurchaseViewPage from "../../../../../entities/DashboardPage/AccountingModule/Purchase/PurchaseView"
import { useLocation } from "react-router-dom";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../../api/AuthService";
import { useAlert } from "../../../../../context/AlertContext";

const PurchaseDetails = () => {
  const [paymentList, setPaymentList] = useState({});
  const { state } = useLocation()
  const { item } = state || {};
  const { showAlert } = useAlert();
  const [status, setStatus] = useState("");
  const [data , setData] = useState([]);

  useEffect(() => {
    getOneBillHandler()
    getAllBanks()
  }, [])

  const handleShowPdf = async () => {
    LoaderHelper.loaderStatus(true);
    const result = await AuthService.getBillView(item?._id);
    LoaderHelper.loaderStatus(false);
    return { __html: result };
  };

  const getAllBanks = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleGetAllCompanyBankAccount();
      if (result?.success) {
        setData(result?.data?.bankAccounts);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleDownloadReceipt = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleDownloadBill(item?._id);
      if (!result) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      } else {
        const blob = new Blob([result], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `FileName.${"pdf"}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleSendBill = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.sendBill(item?._id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const paidBillInvoiceHandler = async (payload) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.paidBillInvoice(payload, item?._id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getOneBillHandler = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getOneBill(item?._id);
      if (result?.success) {
        setPaymentList(result?.data?.payments);
        setStatus(result?.data?.status);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  }

  const handleSubmitData = async (payload, isEditing) => {
    LoaderHelper.loaderStatus(true);
    try {
      let result;
      if (isEditing) {
        result = await AuthService.updateBillPayment(
          item?._id,
          payload.transactionId,
          {
            bankId: payload.bankId,
            type: payload.type,
            date: payload.date,
            amount: payload.amount,
            reference: payload.reference
          }
        );
      } else {
        const invoiceId = String(item?._id);
        result = await AuthService.paidBillInvoice(
          invoiceId,
          {
            bankId: payload.bankId,
            type: payload.type,
            date: payload.date,
            amount: payload.amount,
            reference: payload.reference
          }
        );
      }
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
        getOneBillHandler();
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert("An error occurred while processing your request", "error");
    }
  };

  const deleteRefundHistory = async (transactionId) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteRefundBillHistory(item?._id, transactionId);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
        getOneBillHandler();
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  }

  return (
    <PurchaseViewPage data={data} item={item} handleShowPdf={handleShowPdf} handleDownload={handleDownloadReceipt} handleSendBill={handleSendBill} paidBillInvoiceHandler={paidBillInvoiceHandler} paymentList={paymentList} deleteRefundHistory={deleteRefundHistory} handleSubmitData={handleSubmitData} status={status} />
  )
}

export default PurchaseDetails;
